<template>
  <div onafterprint="myFunction">
    <!-- {{ print }} -->
    <pre class="none">
            <!-- {{ getPrint }} -->
        </pre>

    <!-- <DialogBet v-for="(index, bet) in bets" :data="bet" :key="index"></DialogBet> -->
    <v-container>
      <v-card
        class="white black--text"
        v-for="(bet, index) in bets"
        :data="bet"
        :key="index"
      >
        <v-card
          :class="{ [`elevation-0`]: true }"
          class="viewbet white black--text"
        >
          <v-layout row wrap>
            <v-flex xs12>
              <v-layout row wrap class="px-2 py-3">
                <v-flex xs6 class="font-weight-bold title"
                  >Nº {{ bet.id }}</v-flex
                >
                <v-flex xs6 class="text-xs-right text-sm-left">
                  <div
                    class="d-flex align-center justify-end column fill-height lighten-5 text-xs-right"
                  >
                    {{ bet.date | dataFormat }}
                  </div>
                </v-flex>
              </v-layout>
              <v-divider light></v-divider>
            </v-flex>

            <v-flex xs12>
              <v-layout column wrap v-for="event in bet.events" :key="event[0]">
                <v-layout row nowrap class="px-2 py-1">
                  <v-flex grow xs8 class="wrap">
                    <div>{{ event.tournaments_name }}</div>
                    <div>{{ event.description }}</div>
                    <div>
                      {{ $t("market") }}: {{ markets(event.id_market) }}
                    </div>
                    <div>Odd: {{ results(event.id_outcome, event) }}</div>
                    <div>
                      <span>{{ event.data_evento | dataFormat }}</span>
                    </div>
                  </v-flex>
                  <v-flex shrink xs4 text-xs-right class="">
                    <div class="font-weight-bold">{{ event.factor_event }}</div>
                    <div>
                      <strong
                        v-html="
                          conference(event.result_event, event.status_event)
                        "
                      ></strong>
                    </div>
                  </v-flex>
                </v-layout>
                <v-divider light></v-divider>
              </v-layout>
            </v-flex>

            <v-flex xs12>
              <v-layout row wrap class="pa-2">
                <v-flex v-show="!bet.action" xs6>odds:</v-flex>
                <v-flex v-show="!bet.action" xs6 text-xs-right>{{
                  bet.factor_bet
                }}</v-flex>
                <v-flex xs6>{{ $t("betAmount") }}</v-flex>
                <v-flex xs6 text-xs-right
                  >{{ $t("labelCurrency") }} {{ bet.amount }}</v-flex
                >
                <v-flex v-show="!bet.action" xs6>{{
                  $t("possibleReturn")
                }}</v-flex>
                <v-flex v-show="!bet.action" xs6 text-xs-right>{{
                  bet.prize
                }}</v-flex>

                <v-flex v-show="bet.action" xs6>{{ $t("action") }}</v-flex>
                <v-flex v-show="bet.action" xs6 text-xs-right>{{
                  bet.action
                }}</v-flex>

                <v-flex v-show="bet.action" xs6>{{
                  $t("reversalAmount")
                }}</v-flex>
                <v-flex v-show="bet.action" xs6 text-xs-right
                  >$ {{ bet.factor * bet.amount }}</v-flex
                >

                <v-flex xs6>{{ $t("conference") }}</v-flex>
                <v-flex xs6 text-xs-right>
                  <strong
                    v-html="
                      conference(bet.result_bet, bet.status_bet, bet.reason)
                    "
                  ></strong>
                </v-flex>
              </v-layout>
              <v-divider light></v-divider>
            </v-flex>
          </v-layout>
        </v-card>
      </v-card>
    </v-container>
  </div>
</template>

<style lang="css">
.opacity {
  opacity: 0;
}
@page {
  size: auto;
  margin: 0mm;
}
</style>

<script>
import Vue from "vue";
import { setTimeout } from "timers";

export default {
  name: "print",
  data() {
    return {
      coupons: [],
      bets: [],
    };
  },

  computed: {
    // print: function() {
    //     // const mediaQueryList = window.matchMedia('print');
    //     // const _this = this;
    //     // mediaQueryList.addListener(function(mql) {
    //     //     if(mql.matches == false) {
    //     //         _this.$router.go(-1)
    //     //     }
    //     // });
    // },

    getPrint: function() {
      return this.$store.getters.getPrint;
    },
  },

  mounted() {
    // this.bets = this.$store.getters.getPrint;
    // setTimeout(function() {
    //     window.print()
    // }, 50);

    const evtSource = new EventSource(
      "https://v2.envrelease.com/player/table/liveEvents",
      { withCredentials: false }
    );
    /*
        evtSource.onmessage = function(event) {
        const newElement = document.createElement("li");
        const eventList = document.getElementById("list");
        newElement.innerHTML = "message: " + event.data;
        eventList.appendChild(newElement);
        }
        */
    evtSource.addEventListener("ping", function(event) {
      const newElement = document.createElement("li");
      const time = JSON.parse(event.data).time;
      newElement.innerHTML = "ping at " + time;
      eventList.appendChild(newElement);
    });
  },

  methods: {
    markets: function(index) {
      return this.$store.getters.getMarkets[index].name.replace("{hcp}", "");
    },

    results: function(r, events) {
      if (this.$store.getters.getResults[r] != undefined) {
        return this.$store.getters.getResults[r].name_outcome;
      }
    },

    msgReasion: function(r) {
      const msg_reasion = {
        0: "OTHER",
        1: "NO_GOALSCORER",
        2: "CORRECT_SCORE_MISSING",
        3: "RESULT_UNVERIFIABLE",
        4: "FORMAT_CHANGE",
        5: "CANCELLED_EVENT",
        6: "MISSING_GOALSCORER",
        7: "MATCH_ENDED_IN_WALKOVER",
        8: "DEAD_HEAT",
        9: "RETIRED_OR_DEFAULTED",
        10: "EVENT_ABANDONED",
        11: "EVENT_POSTPONED",
        12: "INCORRECT_ODDS",
        13: "INCORRECT_STATISTICS",
        14: "NO_RESULT_ASSIGNABLE",
        15: "CLIENT_SIDE_SETTLEMENT_NEEDED",
        16: "STARTING_PITCHER_CHANGED",
      };

      return msg_reasion[r];
    },

    conference: function(result_bet, status_bet, reason) {
      if (status_bet == 0) {
        return '<span class="purple--text">Cancelado</span>';
      } else {
        if (result_bet == 1) {
          return '<span class="green--text">Acertou</span>';
        } else if (result_bet == 0 && result_bet != "") {
          if (reason) {
            return `<span class="orange--text">Reembolso</span><strong class="orange--text"> (${this.msgReasion(
              reason
            )})</strong>`;
          } else {
            return '<span class="red--text">Errou</span>';
          }
        } else {
          return '<span class="grey--text">Pendente</span>';
        }
      }
    },
  },
  filters: {
    dataFormat: function(datedb) {
      let date = new Date(`${datedb} UTC`);
      let formatDate = Vue.prototype.$date.format(
        date.toISOString().substring(0, 10),
        "DD/MM/YYYY"
      );
      let hour = date.toISOString().substring(11, 19);
      return `${formatDate} ${hour}`;
    },
  },
};
</script>
